<template>
  <v-navigation-drawer app clipped class="sidebar" color="#173347" dark>
    <div class="sidebar-label">MI ESPACIO</div>
    <v-list nav dense>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        link class="sidebar-item"
        @click="goTo(item.route)"
      >
        <v-list-item-icon>
          <v-icon>${{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div class="sidebar-action" v-if="userRole && userRole!=='investor'">
      <v-btn @click="createProject" class="new-project" block>
        Nuevo Proyecto
      </v-btn>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Sidebar',
  computed:{
    userRole(){
      return this.$store.getters.getUserRole
    },
    items () {
      const items = [
        { title: 'Oportunidades', icon: 'home-city-outline', route:'/explorar' },
        { title: 'Mi cartera', icon: 'chart-donut', route:'/self' }
      ]
      if (this.userRole === 'developer') items.push({ title: 'Mis proyectos', icon: 'office-building-outline', route:'/admin/projects' })
      if (this.userRole === 'admin') {
        items.push({ title: 'Proyectos', icon: 'office-building-outline', route:'/admin/projects' })
        items.push({ title: 'Usuarios', icon: 'account-cog-outline', route:'/users' })
      }
      return items
    }
  },
  methods:{
    goTo(route){
      this.$router.push(route)
    },
    createProject(){
      this.$router.push('/projects/new')
    }
  }

}
</script>

<style scoped>
.sidebar{font-family:Inter,Arial,sans-serif}.sidebar-label{font-size:10px;color:#91a8b5;letter-spacing:1.5px;font-weight:700;padding:28px 24px 10px}.sidebar-item{margin:4px 10px!important;border-radius:0!important;color:#d8e2e6!important}.sidebar-item:hover,.sidebar-item.v-list-item--active{background:rgba(255,255,255,.09)!important;color:#fff!important}.sidebar-item .v-icon{color:#e89178!important}.sidebar-item .v-list-item__title{font-size:12px;font-weight:700}.sidebar-action{position:absolute;bottom:25px;left:18px;right:18px}.new-project{background:#e76f51!important;color:#fff!important;border-radius:0!important;text-transform:none!important;letter-spacing:0!important;font-size:12px;font-weight:700}
</style>
